import React, { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import c from 'classnames';
import { createUseStyles } from 'react-jss';
import MediaQueries from '../tokens/MediaQueries';
import Colours from '../tokens/colours';
import stackOrder from '../tokens/stackOrder';
const useStyles = createUseStyles(() => ({
    backdrop: {
        position: 'fixed',
        zIndex: stackOrder.modal,
        opacity: 0,
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    backdropShown: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: '#00000030',
    },
    dialog: {
        position: 'fixed',
        backgroundColor: Colours.white,
        boxShadow: 'rgb(0 0 0 / 20%) 0px 11px 15px -7px',
        padding: 16,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 4,
        minWidth: '95%',
        minHeight: '95%',
        [MediaQueries.large]: {
            minWidth: 'initial',
            minHeight: 'initial',
        },
    },
}));
function Modal({ className, children, backdrop }) {
    const classes = useStyles();
    const backdropRef = useRef(null);
    useLayoutEffect(() => {
        setTimeout(() => {
            if (backdropRef?.current) {
                backdropRef.current.style.opacity = '1';
            }
        }, 1);
    }, []);
    return createPortal(React.createElement("div", { ref: backdropRef, "aria-hidden": true, className: c(classes.backdrop, backdrop && classes.backdropShown) },
        React.createElement("section", { role: "dialog", tabIndex: -1, className: c(className, classes.dialog) }, children)), document.body);
}
export default Modal;
//# sourceMappingURL=Modal.js.map